import { isAfter } from 'date-fns';

/**
 * Transform API activity booking parts into a download activity tickets for passengers.
 */
export function transformTicketActivity(
    activity: ApiSchema['Activity'],
    apiBooking: ApiSchema['Booking'],
): TicketActivity {
    const passengers = apiBooking.passengers
        .filter(p => activity?.passengerIds.includes(p.id))
        .map(p => transformPassenger(p));
    const fulfillment = apiBooking.fulfillments?.find(f => f.issuer !== 'TOFT' && f.bookingParts?.some(bp => bp.id === activity.id));
    const dateFrom = zurichDate(activity.validFrom);
    const dateUntil = zurichDate(activity.validUntil);

    const id = activity.id;
    const type = 'Activity';
    const summaryLine1 = passengers.map(p => `${p.firstName} ${p.lastName}`).join(', ');
    const summaryLine2 = passengers.map(p => `*${formatMonthMediumYear(p.dateOfBirth)}`).join(', ');
    const detailLine1 = activity.summary ?? '';
    const detailLine2 = formatDateFromTo(dateFrom, dateUntil, true);

    // The downloadable documents (activity vouchers / Wallet passes)
    const documents = fulfillment?.fulfillmentDocuments?.map(d => ({
        download: d.downloadLink ?? '',
        format: d.format,
        type: d.type,
    })) ?? [];

    // Create keycards based on fulfillment party. either Voucher or Swisspass
    const swisspassFulfillmentPart = fulfillment?.fulfillmentParts?.find(
        fp => fp.securityFeatures?.some(sf => sf.type?.type === 'SWISSPASS_REFERENCE'),
    );
    const keycard = swisspassFulfillmentPart
        ? {
                media: 'SWISSPASS' as KeycardMedia,
                reference: swisspassFulfillmentPart.controlId ?? '',
            }
        : {
                media: 'PDF_A4' as KeycardMedia,
                reference: fulfillment?.fulfillmentParts?.[0]?.controlId ?? '',
            };

    // If already in the past
    const isExpired = isAfter(zurichDate(), zurichDate(activity?.validUntil));
    // If already refunded
    const isRefunded = activity.status === 'REFUNDED';
    const isDownloadable
        = documents.length > 0
            && !isExpired
            && !isRefunded;

    return {
        id,
        type,
        summaryLine1,
        summaryLine2,
        detailLine1,
        detailLine2,
        documents,
        keycard,
        isExpired,
        isRefunded,
        isDownloadable,
    };
}
